import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IsLoadingDirective } from './is-loading.directive';
import { IsLoadingSpinnerComponent } from './is-loading-spinner.component';

/**
 * Module that provides the *isLoading structural directive for displaying loading states.
 * 
 * @example
 * // Import in your module
 * import { IsLoadingModule } from '@shared/directives/is-loading-directive/is-loading.module';
 * 
 * @NgModule({
 *   imports: [IsLoadingModule]
 * })
 * export class MyModule {}
 * 
 * @example
 * // Use in your template
 * <div *isLoading="isDataLoading">
 *   <p>{{ data }}</p>
 * </div>
 * 
 * @example
 * // Use with Observable
 * <div *isLoading="loading$">
 *   <p>{{ data }}</p>
 * </div>
 * 
 * @example
 * // Use with custom spinner
 * <div *isLoading="loading$; spinner: mySpinner">
 *   <p>{{ data }}</p>
 * </div>
 * <ng-template #mySpinner>
 *   <div class="custom-spinner">Loading...</div>
 * </ng-template>
 */
@NgModule({
  declarations: [
    IsLoadingDirective,
    IsLoadingSpinnerComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    IsLoadingDirective
  ]
})
export class IsLoadingModule {}
